import { BasicSize } from "../../../componentLibrary/BasicSize.js";
import { Entity } from "../../../entity.js";
import { ASSET_MANAGER } from "../../main.js";
import { CornerSpriteType, WallSpriteDirection } from "../roomData.js";
import { WallSpriteRenderer } from "./wallSpriteRenderer.js";
const CORNER_SIZE = new BasicSize(5, 5, 4);
/**
 * Controller + renderer for walls in a room. This has no correlation to
 * WallEntity - this is purely for aesthetics
 * @author Emma Szebenyi
 */
export class WallSpriteController extends Entity {
    constructor(direction, // wall type
    wallPos, // position to place wall
    wallSize, // wall size
    cornerType, // corner type
    cornerPos) {
        super();
        /* Load wall data */
        if (direction === WallSpriteDirection.LEFT) {
            this.wallSXY = { x: 1, y: 1 };
            this.wallSSize = new BasicSize(5, 720, 1);
        }
        else if (direction === WallSpriteDirection.RIGHT) {
            this.wallSXY = { x: 8, y: 1 };
            this.wallSSize = new BasicSize(5, 720, 1);
        }
        else if (direction === WallSpriteDirection.TOP1) {
            this.wallSXY = { x: 1297, y: 1 };
            this.wallSSize = new BasicSize(1280, 20, 1);
        }
        else if (direction === WallSpriteDirection.TOP2) {
            this.wallSXY = { x: 1611, y: 1 };
            this.wallSSize = new BasicSize(1280, 20, 1);
        }
        else if (direction === WallSpriteDirection.TOP3) {
            this.wallSXY = { x: 1931, y: 1 };
            this.wallSSize = new BasicSize(1280, 20, 1);
        }
        else { // BOTTOM wall
            this.wallSXY = { x: 15, y: 1 };
            this.wallSSize = new BasicSize(1280, 5, 1);
        }
        this.wallPos = wallPos;
        this.wallSize = wallSize;
        const wallSprite = ASSET_MANAGER.getImageAsset("walls");
        if (wallSprite === null)
            throw new Error("Failed to load asset for walls");
        /* Load corner data (if provided) */
        if (cornerType === CornerSpriteType.TR) {
            this.cornerSXY = { x: 8, y: 1 };
        }
        else if (cornerType === CornerSpriteType.BR || cornerType === CornerSpriteType.TL) {
            this.cornerSXY = { x: 1, y: 1 };
        }
        if (cornerPos) {
            this.cornerPos = cornerPos;
        }
        const cornerSprite = ASSET_MANAGER.getImageAsset("corners");
        if (cornerSprite === null)
            throw new Error("Failed to load asset for walls");
        const renderer = new WallSpriteRenderer(wallSprite, this.wallSXY, this.wallSSize, this.wallPos, this.wallSize, cornerSprite, this.cornerSXY, this.cornerPos);
        super.setRenderer(renderer);
    }
}
